import {
    AsyncPipe,
    NgTemplateOutlet,
} from "@angular/common";
import {
    afterNextRender,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    OnInit,
    ViewChild,
} from "@angular/core";
import { IconsDirective } from "@Front-end/seed/modules/icons";
import { SwiperContainer } from "swiper/element";
import { register } from "swiper/element/bundle";
import { SwiperOptions } from "swiper/types";
import { partnersSliderConfig } from "./constants/partners-slider.constants";

@Component({
    selector: "ls-partners-slider",
    imports: [
        IconsDirective,
        AsyncPipe,
        NgTemplateOutlet,
    ],
    templateUrl: "./partners-slider.component.html",
    styleUrl: "./partners-slider.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    host: {
        class: "partners-slider",
    },
  })
export class PartnersSliderComponent implements OnInit {
    constructor(
        private cdr: ChangeDetectorRef,
    ) {
        afterNextRender((): void => {
            this.swiperParams = {
                ...partnersSliderConfig,
                on: {
                    progress: (swiper): void => {
                        this.swiperIsStart = swiper.isBeginning;
                        this.swiperIsEnd = swiper.isEnd;
                        this.cdr.detectChanges();
                    },
                },
            };

            if (this.swiperContainerRef) {
                Object.assign(this.swiperContainerRef.nativeElement, this.swiperParams);
                this.swiperContainerRef.nativeElement.initialize();
            }
        });
    }

    @ViewChild("swiperContainer")
    public swiperContainerRef!: ElementRef<SwiperContainer>;

    public swiperParams: SwiperOptions = { ...partnersSliderConfig };
    public swiperIsStart = true;
    public swiperIsEnd = false;

    public ngOnInit(): void {
        register();
    }
}
